export default __webpack_public_path__ + "images/5dd58f5ce7141c0ea7f97f2b716f55a0.png";